import Icon from 'components/global/Icon';
import Image from 'components/global/Image';
import Typography from 'components/global/Typography';

import { faEllipsis } from '@fortawesome/pro-solid-svg-icons';

import * as S from './styled/CardViewer.styled';

const cardImages = {
	americanexpress: 'https://storage.googleapis.com/tryoto-public/credit-cards/americanExpress.svg',
	applepay: 'https://storage.googleapis.com/tryoto-public/credit-cards/applePay.svg',
	mada: 'https://storage.googleapis.com/tryoto-public/credit-cards/mada.svg',
	mastercard: 'https://storage.googleapis.com/tryoto-public/credit-cards/mastercard.svg',
	visa: 'https://storage.googleapis.com/tryoto-public/credit-cards/visa.svg'
};

const CardViewer = ({ lastFour, cardBrand }) =>
	lastFour && (
		<S.Container>
			<div className="p-1 mx-2" style={{ background: 'var(--white)', border: '1px solid var(--border-color)' }}>
				<Image width="3rem" height="1.5rem" url={cardImages[cardBrand?.toLowerCase()]} alt="card" />
			</div>

			{[...Array(3)].map((_, i) => (
				<Icon
					key={i}
					size="medium"
					icon={faEllipsis}
					color="var(--black)"
					className={i === 3 || i === 7 ? 'px-1' : ''}
				/>
			))}

			<Typography className="px-1">{lastFour}</Typography>
		</S.Container>
	);

export default CardViewer;
